import { Type } from '@sinclair/typebox';
export const ChartPriceSchema = Type.Object({
    price: Type.Object({
        open: Type.String(),
        high: Type.String(),
        close: Type.String(),
        low: Type.String(),
    }),
    marketCap: Type.Object({
        open: Type.String(),
        high: Type.String(),
        close: Type.String(),
        low: Type.String(),
    }),
    volume: Type.String(),
    timestamp: Type.String(),
});
export const CHART_PRICE_PERIODS = [
    '1S',
    '1M',
    '5M',
    '15M',
    '1H',
    '4H',
    '1D',
];
export const ChartPricePeriodSchema = Type.Union([
    Type.Literal('1S'),
    Type.Literal('1M'),
    Type.Literal('5M'),
    Type.Literal('15M'),
    Type.Literal('1H'),
    Type.Literal('4H'),
    Type.Literal('1D'),
]);
export const CHART_PRICE_PERIOD_MS_MAP = {
    '1S': 1000,
    '1M': 1 * 60 * 1000,
    '5M': 5 * 60 * 1000,
    '15M': 15 * 60 * 1000,
    '1H': 60 * 60 * 1000,
    '4H': 4 * 60 * 60 * 1000,
    '1D': 24 * 60 * 60 * 1000,
};
//# sourceMappingURL=chart-price.js.map